import Vue from 'vue'
import VueRouter from 'vue-router'

import { canNavigate } from '@/libs/acl/routeProtection'
import { isUserLoggedIn, getUserData, getHomeRouteForLoggedInUser } from '@/auth/utils'
import { packageLimit } from '@/libs/packageLimits'
/* CORE */
import app from './routes/app'
/* ADMIN:CORE */
import users from './routes/Core/Users'
import userTypes from './routes/Core/User_types'
/* ADMIN:APP */
import projects from './routes/App/Projects'
import guides from './routes/App/Guides'
import tasks from './routes/App/Tasks'
import teams from './routes/App/Teams'

/* ADMIN:DEFINES */
import departments from './routes/Defines/Departments'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    { path: '/', redirect: { name: 'home' } },
    ...app,
    ...userTypes,
    ...users,
    ...departments,
    ...projects,
    ...guides,
    ...tasks,
    ...teams,
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})

router.beforeEach((to, _, next) => {
  try {
    const isLoggedIn = isUserLoggedIn()

    if (!canNavigate(to)) {
      // Redirect to login if not logged in
      if (!isLoggedIn) return next({ name: 'auth-login' })

      // If logged in => not authorized
      return next({ name: 'misc-not-authorized' })
    }

    // Paket limit kontrolü - sadece giriş yapmış kullanıcılar için
    if (isLoggedIn && to.meta.packageLimit) {
      const { subject, limit = 1 } = to.meta.packageLimit
      if (!packageLimit(subject, limit)) {
        return next({ name: 'error-package-limit' })
      }
    }

    // Redirect if logged in
    if (to.meta.redirectIfLoggedIn && isLoggedIn) {
      const userData = getUserData()
      next(getHomeRouteForLoggedInUser(userData ? userData.role : null))
    }

    return next()
  } catch (error) {
    console.error('Router navigation error:', error)
    // Hata durumunda login sayfasına yönlendir
    return next({ name: 'auth-login' })
  }
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
